import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomeBg from "@/assets/backgrounds/PrimaryCurveBg.svg";
import PageLayout from "@/components/custom/PageLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProfileHover } from "@/components/custom/ProfileHover";
import LanguagesIcon from "@/assets/icons/LanguagesIcon.svg";
import { Button } from "@/components/ui/button";
import CarStatusTab from "./CarStatusTab";
import ChargerStatusTab from "./ChargerStatusTab";
import { BottomNav } from "@/components/custom/BottomNav";
import AuthService from "@/services/api/AuthService";
import { setSupervisorDetails } from "@/redux/supervisorDetailsSlice";
import {
  useUserDetails,
  useHubDetails,
  useSupervisorDetails,
} from "@/redux/hooks/useSupervisorDetails";
import { ExternalUserType } from "@/central-atoms/users/enums";
import { useNavigate } from "react-router-dom";
import { clearAuth } from "@/redux/authSlice";
import { LogOutIcon } from "lucide-react";
import { removeActiveFleetId } from "@/utils/appInitializer";
export const Home = () => {
  const dispatch = useDispatch();
  const userDetails = useUserDetails();
  const supervisorDetails = useSupervisorDetails();
  const hubDetails = useHubDetails();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAndFetchSupervisorDetails = async () => {
      if (supervisorDetails) {
        const userType =
          supervisorDetails?.data?.user?.additional_props?.external_user_props
            ?.user_type;
        if (userType === ExternalUserType.EverestDriver) {
          navigate("/driver-home");
        }
      } else {
        try {
          const response = await AuthService.getSupervisorDetails();
          dispatch(setSupervisorDetails(response));
          const userType =
            response?.data?.user?.additional_props?.external_user_props
              ?.user_type;
          if (userType === ExternalUserType.EverestDriver) {
            navigate("/driver-home");
          }
        } catch (error: any) {
          console.error("Error fetching supervisor details:", error);
          if (error?.response?.data?.data?.user?.additional_props?.external_user_props?.user_type === ExternalUserType.EverestDriver) {
            navigate("/driver-home");
          }
          // Handle the error appropriately, e.g., showing an error message
        }
      }
    };

    checkAndFetchSupervisorDetails();
  }, [dispatch, supervisorDetails, navigate]);

  const handleLogout = () => {
    // Clear token from Redux store
    dispatch(clearAuth());
    // Remove token from localStorage
    localStorage.removeItem("auth_token");
    removeActiveFleetId();
    navigate("/signin");
  };

  return (
    <>
      {/* Cover Image */}
      <div className="relative w-full">
        <img
          src={HomeBg}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 items-center flex flex-row justify-between px-6">
          {(userDetails && supervisorDetails?.data.hub_list) ? (
              <ProfileHover
                name={userDetails.name}
                hubList={supervisorDetails.data.hub_list.map((hub) => ({
                  name: hub.name,
                }))}
                selectedHub={hubDetails?.name || ""}
              />
            )
            :
            <Button
              onClick={handleLogout}
              variant="secondary"
              className="w-[100px] flex items-center justify-center gap-1 absolute top-[10px] right-[10px]"
            >
              <LogOutIcon className="w-4 h-4" />
              Logout
            </Button>
          }
          <Button
            variant="icon"
            className="bg-secondary border-none rounded-full"
          >
            <img src={LanguagesIcon} alt="Languages" />
          </Button>
        </div>
      </div>
      <PageLayout>
        <Tabs defaultValue="car" className="w-full">
          <TabsList
            variant="secondary"
            className="grid w-full grid-cols-2 h-12"
          >
            <TabsTrigger variant="secondary" value="car" className="py-2">
              Hub Car Status
            </TabsTrigger>
            <TabsTrigger variant="secondary" value="charger" className="py-2">
              Hub Charger Status
            </TabsTrigger>
          </TabsList>
          {hubDetails?.name && (
            <>
              <TabsContent value="car">
                <CarStatusTab hubName={hubDetails.name} />
              </TabsContent>
              <TabsContent value="charger">
                <ChargerStatusTab hubName={hubDetails.name} />
              </TabsContent>
            </>
          )}
        </Tabs>
      </PageLayout>
      <BottomNav active={1} />
    </>
  );
};

export default Home;
